import { render, staticRenderFns } from "./consultingservice.vue?vue&type=template&id=626459b2&scoped=true&"
import script from "./consultingservice.vue?vue&type=script&lang=js&"
export * from "./consultingservice.vue?vue&type=script&lang=js&"
import style0 from "./consultingservice.vue?vue&type=style&index=0&id=626459b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626459b2",
  null
  
)

export default component.exports